import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IGrievanceForm {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  status?: boolean;

  // email / backend config (resend_api_key is write-only from the server side)
  recipient_email?: string;
  resend_api_key?: string;
  from_email?: string;
  email_subject?: string;

  heading?: string;
  heading_color?: string;

  name_label?: string;
  name_placeholder?: string;
  email_label?: string;
  email_placeholder?: string;
  mobile_label?: string;
  mobile_placeholder?: string;
  query_type_label?: string;
  query_type_placeholder?: string;
  query_type_options?: string;
  category_label?: string;
  category_placeholder?: string;
  category_options?: string;
  subject_label?: string;
  subject_placeholder?: string;
  description_label?: string;
  description_placeholder?: string;

  attachment_enabled?: boolean;
  attachment_checkbox_label?: string;
  attachment_label?: string;
  attachment_help_text?: string;

  submit_text?: string;
  submitting_text?: string;
  success_message?: string;
  error_message?: string;
  required_field_error?: string;

  section_background_color?: string;
  card_background_color?: string;
  label_color?: string;
  input_border_color?: string;
  input_background_color?: string;
  input_text_color?: string;
  submit_button_color?: string;
  submit_button_text_color?: string;
}

export async function createGrievanceForm(payload: Partial<IGrievanceForm>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.GRIEVANCE_FORM.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateGrievanceForm(
  id: number,
  payload: Partial<IGrievanceForm>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.GRIEVANCE_FORM.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
